import React, { Component } from "react";
import { connect } from "react-redux";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints"
import PropTypes from "prop-types";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { StarRating } from "components/glamclub/StarRating"
import { ProductComments } from "./ProductComments";

class ListProductReviews extends Component {
  constructor(props) {
    super(props);

    this.state = {
      reviewsList: []
    }

    this.getProductReviews = this.getProductReviews.bind(this);
    this.listProductReviews = this.listProductReviews.bind(this);
  }

  getProductReviews() {
    ExecuteRequest(
      GlamboxEndpoints.Open.productReviews, 
      null,
      "GET",
      null,
      { 
        productId: this.props.productId
      },
      (response) => {
        let {
          result,
          statusCode
        } = response;
        
        if (statusCode === 200) {
          this.setState({
            reviewsList: result 
          });
        }
      }
    )
  }

  listProductReviews() {
    let reviewsList = this.state.reviewsList;
    return reviewsList.map((item, key) => {
      return (
        <tr key={key}>
          <td valign="top">{item.nickname}</td>
          <td valign="top">{item.reviewTitle}</td>
          <td><StarRating rating={item.rating} /> </td>
          <td>{item.review} </td>
        </tr>
      )
    });
  }

  componentDidMount() {
    this.getProductReviews();
  }

  sendReviewSuccess = () => {
    this.getProductReviews();
  };

  render() {
    let reviewsList = this.state.reviewsList;

    return (
      <ProductComments 
        comments={reviewsList} 
        rating={this.props.rating} 
        productId={this.props.productId}
        onReviewSuccess={this.sendReviewSuccess}/>
    );
  }
}

/*
ListProductReviews.propTypes={
    productId: PropTypes.number.isRequired
}*/
export { ListProductReviews };